<template>
  <div class="modal fade" id="selectMotiveToPause" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <span class="first-title">Marcar pausa</span>
        </div>

        <div class="modal-body">
          <div class="modal-custom">
            <!-- Loading -->
            <div v-if="loadingMotives" class="loading center_vertical">
              <div class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </div>

            <!-- Content -->
            <form v-if="!loadingMotives" name="form" class="form-modal" novalidate>
              <div class="custom-input">
                <label>Selecione um motivo de pausa <span>*</span></label>
                <select v-model="motiveSelected">
                  <option value="">Selecione</option>
                  <option v-for="m in dataMotives" v-bind:value="m">{{m.motive}} <span v-if="m.time > 0"> ({{m.time}}min)</span></option>
                </select>
              </div>
            </form>
          </div>
        </div>

        <div class="modal-footer">
          <button v-if="!loadingMotives" v-on:click="closeModal()" class="btn-close">Cancelar</button>
          <button v-if="!loadingMotives" v-on:click="confirmPause()" :disabled="loadingModal || motiveSelected == ''" v-bind:class="{'disable': loadingModal}" type="submit" class="btn-save">
            <span v-if="!loadingModal">Confirmar pausa</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { PAUSE_MODAL_INFO } from "../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../requestConfig";
  import { UTIL_SERVICE } from "../../../utils";

  export default {
    name: "modalSelectMotiveToPause",
    props: ['callRequest'],
    data() {
      return {
        loadingMotives: false,
        loadingModal: false,
        dataMotives: "",
        motiveSelected: "",
        confirmMotive: "",
        inPauseMotive: ""
      }
    },
    watch: {
      callRequest: function(val) {
        this.checkPauseInfo();
      },
      confirmMotive : function(val){
        this.$emit('update:confirmPauseModal', val)
      }
    },
    methods: {
      checkPauseInfo() {
        this.loadingMotives = true;

        let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        REQUEST_SERVICE.get(PAUSE_MODAL_INFO + userInfo.id).then((response) => {
          UTIL_SERVICE.console("RESULT PAUSE_MODAL_INFO:", response.data);

          this.dataMotives = response.data.motives;
          if (response.data.actualPause.companyPauseMotive) {
            this.inPauseMotive = response.data.actualPause.companyPauseMotive;
          }
          this.loadingMotives = false;
        }).catch(reason => {
          this.loadingMotives = false;
        });
      },
      confirmPause() {
        if (this.motiveSelected) {
          if (this.motiveSelected.id) {
            $('#selectMotiveToPause').modal('toggle');
            $('.modal-backdrop').remove();

            this.confirmMotive = this.motiveSelected;
          }
        }
      },
      closeModal(){
        $('#selectMotiveToPause').modal('toggle');
        $('.modal-backdrop').remove();
      }
    }
  }
</script>

<style lang="scss" scoped>

.modal-dialog {
  @media only screen and (max-width: 430px) {
    width: 95%;
  }
}

#selectMotiveToPause {
  .modal-dialog {
    max-width: 401px;
    width: 100%;

    @media screen and (max-width: 430px) {
      width: 95% !important;
    }

    .modal-content {
      padding: 30px;
      box-shadow: none;
      border: none;
      border-radius: 8px;

      .modal-header {
        padding: 0 0 10px;
        border-bottom: 1px solid var(--bodyColor);

        .first-title {
          display: flex;
          align-items: center;
          color: var(--titleBox);
          font-size: 21px;
          font-weight: 700;
          line-height: 25.6px;
        }
      }

      .modal-body {
        padding: 30px 0 20px 0;
        border-bottom: 1px solid var(--bodyColor);

        .modal-custom {
          .custom-input {
            label {
              margin-bottom: 3px;
              color: var(--defaultText);
              font-size: 14px;
              font-weight: 400;

              span {
                color: var(--redColor);
              }
            }

            select {
              font-size: 16px;
              font-weight: 400;
              background: var(--bodyColor) !important;
              color: var(--titleBox) !important;
              padding: 5px 11px;
              border-radius: 2px;
              border: 1px solid var(--bodyColor);
              transition: .2s;

              &:hover {
                border-color: var(--titleSide);
              }
            }
          }
        }
      }

      .modal-footer {
        display: flex;
        justify-content: flex-end;
        padding: 20px 0 0 0;

        .btn-save {
          position: relative;
          background: var(--linkColor);
          padding: 8px 25px;
          border: none;
          border-radius: 4px;
          transition: .2s;

          span {
            color: #fff;
          }

          &:disabled {
            background: cadetblue;
            filter: grayscale(1);
            cursor: no-drop;
          }
        }

        .btn-close {
          padding: 8px 25px;
          margin-right: 15px;
          border: none;
          border-radius: 4px;
          transition: .2s;
          color: #3a424e;
          background: #d5dfeb;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalSelectMotiveToPause.vue